import secrets from './secrets';

const img_url = require('./assets/images/london.jpg');
const logotext = "SG";
const meta = {
    title: "Seth G. Odia",
    description: "I’m Seth Odia Algo developer, currently working in London",
};

const introdata = {
    title: "Seth G. Odia",
    animated: {
        first: "Technology",
        second: "Finance",
        third: "Art",
    },
    description: "Algo developer, currently working in London. I have a strong background in building financial trading software and a keen interest in the art world.",
    your_img_url: img_url, 
};

const dataabout = {
    title: "A BIT ABOUT MYSELF",
    aboutme: "I am an algo developer with a passion for finance and art. I have a strong background in building trading execution algo software in the financial sector and a keen interest in the art world. I am currently working in London.",
};
const worktimeline = [{
        jobtitle: "Algo Developer",
        where: "BNP Paribas CIB",
        date: "2022 - Present",
    },
];

const skills = [{
        name: "Algorithmic Trading",
        value: 80,
    },
    {
        name: "Equities",
        value: 60,
    },
    {
        name: "C++",
        value: 90,
    },
    {
        name: "Python",
        value: 85,
    },
];

const services = [{
    title: "Static Websites",
    description: "I create responsive and visually appealing static websites tailored to your needs.",
    },
    // {
    // title: "Art Dealing",
    // description: "I offer professional art dealing services, connecting buyers with unique and valuable pieces.",
    // },
];

const dataportfolio = [{
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/800/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/600/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/300/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/700/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },

    {
        img: "https://picsum.photos/400/600/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/300/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/550/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/700/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
];

const contactConfig = {
    YOUR_EMAIL: "contact@sgodia.com",
    YOUR_FONE: "(555)123-4567",
    description: "Feel free to reach out for any inquiries or collaborations. I am always open to discussing new projects, creative ideas, or opportunities to be part of your vision.",
    YOUR_SERVICE_ID: secrets.YOUR_SERVICE_ID,
    YOUR_TEMPLATE_ID: secrets.YOUR_TEMPLATE_ID,
    YOUR_USER_ID: secrets.YOUR_USER_ID,
};

const socialprofils = {
    github: "https://github.com/sethGGO",
    linkedin: "https://www.linkedin.com/in/seth-odia",
    twitter: "https://twitter.com",
};

export const databooks = [
    {
        title: "A Man for All Markets",
        author: "Edward O. Thorp",
        cover: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1471282417i/25733505.jpg",
        description: "From Las Vegas to Wall Street, the incredible story of how a math professor became a casino killer and stock market star.",
        link: "https://www.goodreads.com/book/show/25733505-a-man-for-all-markets"
    },
    {
        title: "Zero to One",
        author: "Peter Thiel", 
        cover: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1630663027i/18050143.jpg",
        description: "Notes on startups, or how to build the future. Peter Thiel shows how we can find singular ways to create those new things.",
        link: "https://www.goodreads.com/book/show/18050143-zero-to-one"
    },
    {
        title: "The Psychology of Money",
        author: "Morgan Housel",
        cover: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1581527774i/41881472.jpg",
        description: "Timeless lessons on wealth, greed, and happiness. The book explores the strange ways people think about money and teaches you how to make better sense of one of life's most important topics.",
        link: "https://www.goodreads.com/book/show/41881472-the-psychology-of-money"
    },
    {
        title: "The $12 Million Stuffed Shark",
        author: "Don Thompson",
        cover: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1312070032i/3717320.jpg",
        description: "The curious economics of contemporary art and auction houses, revealing the dynamics behind the astronomical prices in the art market.",
        link: "https://www.goodreads.com/book/show/3717320-the-12-million-stuffed-shark"
    },
    {
        title: "Flash Boys",
        author: "Michael Lewis",
        cover: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1426093936i/24724602.jpg",
        description: "A Wall Street revolt exploring the hidden world of high-frequency trading and its impact on markets.",
        link: "https://www.goodreads.com/book/show/24724602-flash-boys"
    },
    {
        title: "Formation: The Making of Nigeria from Jihad to Amalgamation",
        author: "Fola Fagbule",
        cover: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1605685052i/55925096.jpg",
        description: "A comprehensive exploration of the events, people and politics that shaped Nigeria's early history from 1804-1914.",
        link: "https://www.goodreads.com/book/show/55925096-formation"
    },
    {
        title: "A Fatherless People",
        author: "Dele Ogun",
        cover: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1542255832i/42800395.jpg",
        description: "A critical examination of Nigeria's leadership and political development from colonial times to the present.",
        link: "https://www.goodreads.com/book/show/42800395-a-fatherless-people"
    }
];

export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};